/* @flow */
import React from 'react';
import { Container } from 'flux/utils';

import Chat, { MAX_PARTICIPANTS_REPLIES_ENABLE } from 'entities/Chat';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph.jsx';
import Group from 'entities/Group';
import Link from 'components/Link.jsx';
import LinkConstants from 'constants/LinkConstants';
import MessageStore from 'groups/stores/MessageStore';
import Timestamp from 'components/Timestamp.jsx';
import { mountModal } from 'lib/modal.js';
import { getGroupKey } from 'utils/roleHelpers';

import ScheduledAnnouncementsDialog from './ScheduledAnnouncementsDialog.jsx';

import './styles/ComposerAlert.scss';

class ComposerAlert extends React.Component {

  static propTypes = {
    chat: React.PropTypes.instanceOf(Chat),
    group: React.PropTypes.instanceOf(Group),
    target: React.PropTypes.object,
    openSideBar: React.PropTypes.func,
  };

  static getStores() {
    return [MessageStore];
  }

  static calculateState(prevState, props) {
    const { group, target } = props;
    let role = '';
    if (target) {
      role = target.role;
    }
    if (group) {
      return {
        messagesScheduled: MessageStore.getMessagesScheduled(getGroupKey(group.id, role)),
      };
    }

    return {};
  }

  constructor(props) {
    super(props);
    this.state = {
      messagesScheduled: [],
    };
  }

  openScheduledMessagesDialog() {
    const { messagesScheduled } = this.state;
    mountModal(
      <ScheduledAnnouncementsDialog
        messagesScheduled={messagesScheduled}
        group={this.props.group}
        target={this.props.target}
      />, this);
  }

  renderOfficeHoursNotice() {
    const { chat } = this.props;

    if (!chat || chat.isUnsubscribed() || !chat.isPresent() || chat.getLeftMemberships()[0]) {
      return null;
    }

    let message;
    if (chat.isOutsideOfOtherOfficeHours()) {
      message = (
        <div>
          <Glyph name="clock" />
          It’s outside of office hours.
        </div>
      );
    } else if (!CurrentUser.getUser().getOfficeHours().isAvailableNow()) {
      message = (
        <Link color="pitch" to="/settings/chat">
          <Glyph name="clock" />
          It’s outside of your office hours.
        </Link>
      );
    }

    if (message) {
      return (
        <div className="ComposerAlert ComposerAlert-officeHours">
          {message}
        </div>
      );
    }
    return null;
  }

  renderRepliesDisabledNotice() {
    const { chat } = this.props;
    let message = 'Replies are turned off';

    if (chat.getMemberships().length > MAX_PARTICIPANTS_REPLIES_ENABLE) {
      message = `Replies are turned off for group conversations with more than ${MAX_PARTICIPANTS_REPLIES_ENABLE} participants.`;
    }
    return (
      <div
        className="ComposerAlert ComposerAlert-repliesDisabled"
        onClick={this.props.openSideBar}>
        <Glyph name="chat-close-bubble-fill" size="large" />
        {message}
      </div>
    );
  }

  renderUserMutedNotice() {
    const currentUser = CurrentUser.getUser();
    const timestamp = <Timestamp date={currentUser.getMutedUntil()} format="long" />;

    return (
      <div className="ComposerAlert">
        <Glyph name="chat-close-bubble-fill" size="large" />
        Your messaging privileges have been suspended until {timestamp}.
        {' '}
        <Link color="blue" href={LinkConstants.COMMUNITY_GUIDELINES} target="_blank">More Information</Link>.
      </div>
    );
  }

  renderMembersMutedNotice() {
    const { chat } = this.props;

    const otherMember = chat.getOtherMember();
    const name = otherMember && otherMember.id !== -1 ?
      otherMember.name : 'Some participants in this conversation';

    const message = `${name} may not be able to respond to your message right now.`;

    return (
      <div className="ComposerAlert">
        {message}
      </div>
    );
  }

  renderScheduledMessagesNotice() {
    const numScheduled = this.state.messagesScheduled.length;
    const noticeText = (numScheduled > 1)
      ? numScheduled + ' scheduled announcements'
      : '1 scheduled announcement';
    return (
      <div
        className="ComposerAlert ComposerAlert-scheduledMessages"
        onClick={() => { this.openScheduledMessagesDialog(); }}>
        <Glyph name="schedule" />
        {noticeText}
      </div>
    );
  }

  render() {
    const { chat, group } = this.props;

    if (CurrentUser.getUser().isMuted()) {
      return this.renderUserMutedNotice();
    }

    if (chat) {
      // NOTE: Should be repliesDisabled() but there may be a backend bug right now
      if (chat.isDisabled()) {
        return this.renderRepliesDisabledNotice();
      } else if (chat.hasMutedMembers()) {
        return this.renderMembersMutedNotice();
      } else {
        return this.renderOfficeHoursNotice();
      }
    }

    if (group && this.state.messagesScheduled.length > 0) {
      return this.renderScheduledMessagesNotice();
    }

    return null;
  }
}

export default Container.create(ComposerAlert, {
  withProps: true,
  pure: false,
});



// WEBPACK FOOTER //
// ./src/chat/components/ComposerAlert.jsx